import React from "react";

import styles from "./Header.module.scss";

import HeaderTop from "./HeaderParts/HeaderTop/HeaderTop";
import HeaderMiddle from "./HeaderParts/HeaderMiddle/HeaderMiddle";
import HeaderBottom from "./HeaderParts/HeaderBottom/HeaderBottom";
import HeaderBurger from "./HeaderParts/HeaderBurger/HeaderBurger";

const Header: React.FC = () => {
  const [isScrolled, setIsScrolled] = React.useState(false);

  React.useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header className={`${styles.header} ${isScrolled ? styles.scrolled : ""}`}>
      <div className="container">
        <div className={styles.floors}>
          <HeaderTop />
          <hr className={styles.hr} />
          <HeaderMiddle />
          <HeaderBottom />
        </div>
        <HeaderBurger />
      </div>
    </header>
  );
};

export default Header;
